/**
 * Saves `text` as a file through a temporary `<a download>` — same approach as the
 * render preview's PNG download (`render-preview-modal.tsx`). The object URL is
 * revoked right after the click: the browser has already taken the blob by then.
 */
export function downloadTextFile(text: string, fileName: string, mime = 'application/json'): void {
  const url = URL.createObjectURL(new Blob([text], { type: `${mime};charset=utf-8` }));
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}
